import React from "react";
import "./style.css";
import OfferImg from "../../../assets/img/banner/WhatsApp Image 2026-03-02 at 2.52.46 PM.jpeg";

const WhatWeOffer = () => {
  return (
    <section className="what_we_offer_section section_padding">
      <div className="container">
        <div className="row align-items-center who-we-are-row">
          <div className="col-lg-4 col-md-12 who_we_are_img_col">
            <div className="who_we_are_img">
              <img src={OfferImg} alt="What We Offer" className="img-fluid" />
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 who_we_are_text_col"
            style={{ marginTop: "5%" }}
          >
            <div className="who_we_are_content">
              <h2 className="who_we_are_heading">How We Support</h2>
              <div className="who_we_are_subheading">
                Empowering Mothers, Building Community
              </div>
              {/* <p className="who_we_are_paragraph" >
                               Our support program is  designed to empower and assist
                                expectant single mothers through their journey of motherhood. We provide
                                education, emotional and social support, and practical assistance
                                to ensure every mother feels seen, supported, and valued.
                            </p> */}
              <div className="who_we_are_support_steps">
                {/* <h3>How we support:</h3> */}
                <br />
                <ul className="who_we_are_paragraph">
                  <li>- Single mom-to-be reaches out for our help</li>
                  <li>- She fills out the get support form</li>
                  <li>- A coordinator reaches out to her with warmth</li>
                  <li>- Pregnancy is confirmed</li>
                  <li>- Mom attends a 7 weeks equipping class</li>
                  <li>- We honor her with a baby shower </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
